import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import FilterController from './FilterController';
import { useState } from 'react';
import { FilterStateIcon } from '@/widget/Icon';
import { useTheme } from '@/components/ThemeProvider';
import { useSignalStore } from '../../store';

export default () => {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const { filterConfig } = useSignalStore();
  const apply =
    !filterConfig.alertTimes.start &&
    !filterConfig.alertTimes.end &&
    !filterConfig.mc.start &&
    !filterConfig.mc.end &&
    !filterConfig.liquidity.start &&
    !filterConfig.liquidity.end &&
    !filterConfig.holders.start &&
    !filterConfig.holders.end;
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger>
        <div className="px-[8px] h-[32px] rounded-[8px] text-[12px] flex border-borderColor border-[1px] items-center gap-x-[4px]">
          <FilterStateIcon theme={theme} apply={!apply} className="size-[18px]" />
        </div>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        hideCloseIcon
        className="p-[16px] pb-[40px] border-t-[1px] overflow-y-auto border-t-borderColor min-h-[500px] rounded-tl-[12px] rounded-tr-[12px] outline-none"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader className="hidden" />
        <SheetTitle className="hidden" />
        <SheetDescription className="hidden" />
        <FilterController setOpen={setOpen} />
      </SheetContent>
    </Sheet>
  );
};
